import {
  Box,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import SearchIcon from "@mui/icons-material/Search";

ChartJS.register(ArcElement, Tooltip, Legend);

function CandidateChart() {
  const data1 = {
    labels: ["Got Placed", "Trained Candidates",],
    datasets: [
      {
        label: "%",
        data: [48.8, 24.3, 26.9],
        borderColor: ["rgba(255,206,86,0.2)"],
        backgroundColor: ["#2544EE", "#ECE9FF", "#ACD4F7"],
        pointBackgroundColor: "rgba(255,206,86,0.2)",
      },
    ],
  };
  const data2 = {
    labels: ["Coaches Growth  in Last 6 Months",],
    datasets: [
      {
        label: "%",
        data: [48.8, 51.2],
        borderColor: ["rgba(255,206,86,0.2)"],
        backgroundColor: ["#2544EE", "#ECE9FF", "#ACD4F7"],
        pointBackgroundColor: "rgba(255,206,86,0.2)",
      },
    ],
  };
  const data3 = {
    labels: ["IT Service", "Health Care", "Manufacturing", "Production"],
    datasets: [
      {
        label: "%",
        data: [16.8, 32.8, 24.3, 26.9],
        borderColor: ["rgba(255,206,86,0.2)"],
        backgroundColor: ["#2544EE", "#ECE9FF", "#ACD4F7","#8BACF8"],
        pointBackgroundColor: "rgba(255,206,86,0.2)",
      },
    ],
  };


  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent:'space-between',
          mt: 8,
          borderRadius: "10px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: { md: "30px", xs: "20px" },
            lineHeight: "36px",
            color: "#000000",
          }}
        >
          Welcome to <span style={{color:'#2544EE'}}>PPLACD</span>
        </Typography>
        <Grid
          item
          md={4}
          sx={{
            display: "flex",
            verticalAlign: "middle",
            alignItems: "center",
          }}
        >
          <TextField
            sx={{ marginLeft: "1rem" }}
            className="profile-skills-box text2Light"
            variant="outlined"
            size="small"
            placeholder="Search"
            InputProps={{
              endAdornment: <SearchIcon sx={{ opacity: "0.5" }} />,
            }}
          />
        </Grid>
      </Box>


      <Box sx={{display:'flex',flexDirection:{md:'row', xs:'column'}, justifyContent:'space-between', mt:4, bgcolor:'#F8FAFF', p:3,borderRadius:'15px', boxShadow: '0px 23.48060417175293px 46.96120834350586px -8.80522632598877px #3665D014', border: '1px solid #D2D2D299'
}}>
    <Box><Typography className="subHeading2Bold">Job Applied : <span style={{color:'#2544EE'}}>0</span></Typography></Box>
    <Box><Typography className="subHeading2Bold">Interviews : <span style={{color:'#2544EE'}}>0</span></Typography></Box>
    <Box><Typography className="subHeading2Bold">Active Services : <span style={{color:'#2544EE'}}>0</span></Typography></Box>
   
</Box>

      <Box sx={{ pt: 5 }}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Paper>
              <Box
                sx={{
                  textAlign: "start",
                  p: 2,
                  fontSize: "22px",
                  fontWeight: 600,
                  fontFamily: "Inter",
                }}
              >
                <Box>
                  <Typography pb={1} className="subHeading2Bold">How Many Got Placed</Typography>
                  <Divider />
                </Box>
                <Box p={3}>
                <Doughnut data={data1}  />
                </Box>
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper>
              <Box
                sx={{
                  textAlign: "start",
                  p: 2,
                  fontSize: "22px",
                  fontWeight: 600,
                  fontFamily: "Inter",
                }}
              >
                <Box>
                  <Typography pb={1} className="subHeading2Bold">Coaches Growth</Typography>
                  <Divider />
                </Box>
                <Box p={3}>
                <Doughnut data={data2}  />
                </Box>
              
              </Box>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4}>
            <Paper>
              <Box
                sx={{
                  textAlign: "start",
                  p: 2,
                  fontSize: "22px",
                  fontWeight: 600,
                  fontFamily: "Inter",
                }}
              >
                <Box>
                  <Typography pb={1} className="subHeading2Bold">Companies Sector</Typography>
                  <Divider />
                </Box>
                <Box p={3}>
                <Doughnut data={data3}  />
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>



    </Box>
  );
}

export default CandidateChart;
